<template>
   <v-app id="inspire" align='center'>
      <v-main>
         <v-container fluid fill-height>
            <v-layout align-center justify-center>
               <v-flex xs12 sm8 md4>
                  <v-alert dense text v-if="show" type="error" >
                     Email хаяг/Нууц үг буруу байна!
                  </v-alert>
                  <v-alert dense text v-if="show2" type="error" >
                     Та эрхийн хугацаа дууссан байна!
                  </v-alert>
                  <v-card class="elevation-12">
                     <v-toolbar dark color="grey darken-2">
                        <v-toolbar-title>Admin Panel</v-toolbar-title>
                     </v-toolbar>
                     <v-card-text>
                        <v-form ref="form">
                           <v-text-field
                              prepend-icon="mdi-account"
                              v-model="email"
                              name="email"
                              label="Email хаяг"
                              :rules="[required]"
                              type="text"
                           ></v-text-field>
                           <v-text-field
                              prepend-icon="mdi-lock"
                              v-model="password"
                              name="password"
                              label="Нууц үг"
                              :rules="[required]"
                              type="password"
                           ></v-text-field>
                        </v-form>
                     </v-card-text>
                     <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn :loading="loading" color="grey lighten-2" @click="login">LOGIN</v-btn>
                     </v-card-actions>
                  </v-card>
               </v-flex>
            </v-layout>
         </v-container>
      </v-main>
      <v-footer id='app'>
         <v-flex class='text-xs-center'>© 2021. All rights reserved. Excel Finance</v-flex>
      </v-footer>
   </v-app>
</template>

<script>
export default {
   data (){
      return {
        email: '',
        password: '',
        status: null,
        loading: false,
      }
   },
   computed: {
      show() {
         return this.status === 401;
      },
      show2() {
         return this.status === 402;
      }
   },
   methods: {
      required(value) {
        if (value instanceof Array && value.length == 0) {
          return 'Заавал утга оруулна уу.';
        }
        return !!value || 'Заавал утга оруулна уу.';
      },

      login (){
         if (!this.$refs.form.validate()) {
          return;
         }
         this.loading = true;
         let email = this.email 
         let password = this.password
         this.$store.dispatch('login', { email, password })
            .then(() => {
               this.loading = false;
               this.$router.push('/')
            })
            .catch(err => {
               this.loading = false;
               this.status = err.response.status;
               setTimeout(() => {
                  this.status = null;
                  // console.log(this.show)
               }, 5000)
               // this.status = 401;
               console.log(err)
            })
      }
   }
};
</script>

<style></style>
